module.exports = __webpack_public_path__ + "img/75693.fd644af1.svg";